import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const selectCurrencySettings = (state: RootState) => {
  const payload = state.settings?.settings;
  return payload?.settings ?? payload ?? {};
};
export const selectBaseCurrencyId = (state: RootState) => {
  const settings = selectCurrencySettings(state);
  return settings.currencyId ?? settings.currency_id ?? settings.currency?.id ?? state.auth?.user?.currencyId ?? state.auth?.user?.currency_id;
};
const label = (currency: unknown): string => {
  if (typeof currency === 'string') return currency;
  if (currency && typeof currency === 'object') {
    const data = currency as Record<string, unknown>;
    return String(data.symbol || data.code || data.name || '');
  }
  return '';
};

/**
 * Single canonical selector for determining the display currency symbol.
 * Resolves in priority order:
 * 1. Global Settings Currency (from API, under `settings.settings`)
 * 2. User's specific Currency Preference
 * 3. Company Info Currency
 * 4. Fallback to empty string
 */
export const selectDisplayCurrency = createSelector(
  [
    (state: RootState) => selectCurrencySettings(state).currency,
    (state: RootState) => state.auth?.user?.currency,
    (state: RootState) => state.settings?.companyInfo?.currency,
  ],
  (settingCurrency, userCurrency, companyCurrency) => {
    return label(settingCurrency) || label(userCurrency) || label(companyCurrency);
  }
);
